import { FIND_FILE_REFERENCES_REQUEST, findFileReferencesSuccess, findFileReferencesFailure } from 'Redux/Action';
import { ofType }                                                                             from 'redux-observable';
import { from }                                                                               from 'rxjs';
import { mergeMap }                                                                           from 'rxjs/operators';
import { TEpic }                                                                              from 'Redux/Config';

export const findFileReferencesEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
  return action$.pipe(
    ofType(FIND_FILE_REFERENCES_REQUEST),
    mergeMap(action => from(
      FileReferenceRepository.findAll(action.payload)
        .then(({ fileReferences, meta }) => findFileReferencesSuccess({
          fileReferences,
          response: meta,
          request: action
        }))
        .catch((error: Error) => findFileReferencesFailure(error)),
    )),
  );
};
